<template>
  <!-- 对话框 -->
  <el-dialog :visible.sync="show" width="500px" :before-close="closeDialog" center>

    <div style="max-height: 50vh ;overflow-y: auto;" class="box" v-loading='loading'>
      <el-form label-width="80px">

        <el-form-item label="支付方式:" label-width='120px'>



          <el-radio-group v-model="submit_data.pay_mode">
            <el-radio-button label="offline">线下支付</el-radio-button>
            <el-radio-button label="online">线上支付</el-radio-button>
            <!-- <el-radio-button label="wallet">余额支付</el-radio-button> -->
          </el-radio-group>

        </el-form-item>

        <el-form-item label="支付金额:" label-width='120px'>

          <el-input v-model="submit_data.finish_amount" :placeholder="submit_rules.finish_amount.placeholder"
            style="width: 100px;margin-right: 5px;"></el-input>元

        </el-form-item>

        <el-form-item label="备注:" label-width='120px'>

          <el-input v-model="submit_data.system_remarks" type="textarea" style="width: 200px;margin-right: 5px;">
          </el-input>

        </el-form-item>

      </el-form>





    </div>

    <!-- 对话框底部按钮 -->
    <span slot="footer" class="dialog-footer">
      <submitBtn @onSubmitDig="onSubmitDig" :data="submit_data" :rules="submit_rules" :url="'/order/editPaymentSubmit'" :JSON_Boolean="false"></submitBtn>
      <el-button @click="closeDialog">返回</el-button>
    </span>

  </el-dialog>
</template>

<script>
  var _this;
  export default {

    props: {
      'isShow': Boolean,
      'data': '',
      'money': ''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;

        _this.submit_data.order_code = _this.data;



        _this.submit_rules.finish_amount.placeholder = _this.money;

        _this.$post(
            "/order/getOrderDetails", {
              order_code: _this.data,
              coordinate: '0',
              synchronization: '0',
              order_track: '0',
              order_difference: '0'
            }
          )
          .then(res => {
            _this.loading = false;

            _this.order_details = res.data;

            _this.submit_data.pay_mode = res.data.order_details.pay_mode.val;

            _this.submit_data.finish_amount = res.data.order_details.finish_amount;

            _this.submit_data.system_remarks = res.data.order_details.system_remarks;


          }).catch(res => {

          })


      },
    },
    data() {
      return {


        show: false,
        loading:true,

        order_details: [],



        // 表单数据
        submit_data: {
          order_code: '',
          pay_mode: '',
          finish_amount: '',
          system_remarks: ''
        },
        submit_rules: {
          pay_mode: {
            placeholder: '支付方式',
            rules: {
              required: true,
              message: '支付方式未选择',
              regulation: 'egt_str',
              rulesData: 0
            }
          },
          finish_amount: {
            placeholder: '支付金额',
            rules: {
              required: false,
              message: '未填写支付金额',
              regulation: 'egt_str',
              rulesData: 0
            }
          },
        }

      };
    },
    created() {

      _this = this;

    },
    methods: {
      onSubmitDig() {



            _this.$emit('onSubmit');
            _this.closeDialog();


      },



      closeDialog() {

        _this.submit_data = {
          order_code: '',
          pay_mode: '',
          finish_amount: '',
          system_remarks: ''
        }
        _this.show = false;


      },



    }
  };
</script>

<style scoped>
  #container_add {
    height: 90%;
    width: 65%;
    float: left;
  }

  .order-model {
    margin: 20px 0;
  }


  .mode-data {

    margin: 20px 0;
  }

  iframe {
    width: 100%;
    border: medium none;
    height: 100%;
  }

  h4 {
    font-size: 24px;
    text-align: center;
    margin-bottom: 20px;
  }

  h5 {
    font-size: 20px;
    font-weight: normal;
  }

  .text-btn {
    font-size: 18px;
    margin-left: 20px;
    padding: 5px;
    display: block;
  }

  .box>div {
    margin: 20px 0;
  }
</style>